import React from "react";
import Image from "next/image";
import CtaOne from "@components/CTA/CtaOne";
import { ButtonPrimary } from "@components/Buttons";
import { createUTMQueryParams } from "@utils/signature_owner";

const Subscribe = ({
  heading = "Simple and Budget-Friendly Signing for Your Business",
  paragraph = "One fixed price for unlimited signatures, templates, forms, and contracts—no extra charges for adding users and more signatures.",
}) => {
  return (
    <div className="py-20 lg:py-40 mx-auto px-4 md:px-8 xxl:px-0">
      <div className="max-w-screen-mxl mx-auto flex flex-col lg:flex-row gap-10">
        <div className="flex-1">
          <CtaOne heading2={heading} paragraph={paragraph} />
          <div className="flex flex-col sm:flex-row gap-6">
            {/* <input
              type="text"
              name=""
              id=""
              className="border border-gray-700 rounded-md outline-none px-4 text-gray-800 w-full xs:w-[380px] h-[52px] bg-white placeholder-gray-800"
              placeholder="Enter Email Address"
            /> */}
            {/* <ButtonPrimary
              buttonText={`Subscribe`}
              buttonUrl={`#`}
              borderShadow={false}
              icon={false}
            /> */}
            <CtaOne
              buttonPrimaryText={`Get Started`}
              buttonPrimaryUrl={`https://signature.boloforms.com/register?from=WEBSITE_BOTTOM_BUTTON${createUTMQueryParams(
                {
                  from: "WEBSITE_BOTTOM_BUTTON",
                }
              )}`}
            />
          </div>
        </div>
        <div className="w-full h-[500px] lg:h-auto lg:flex-1 relative">
          <Image
            src={require("@assets/landing-page/hero1.png")}
            width={10}
            height={10}
            className={`moveRightAndCenterObject rounded-lg w-auto h-[50%] xs:h-[50%] sm:h-[70%] xl:h-[80%] imageBorders absolute left-[10%] top-1/2 z-10`}
            alt="hero"
          />
          <Image
            src={require("@assets/landing-page/only_solution2.png")}
            width={10}
            height={10}
            className={`moveCornerLeftRotateLeftObject rounded-lg w-auto h-[30%] xs:h-[40%] sm:h-[50%] lg:h-[40%] xl:h-[65%] imageBorders absolute right-[5%] sm:right-[15%] md:right-[20%] xxl:right-[15%] top-0 lg:top-[-10%] z-10`}
            alt="hero"
          />
          <Image
            src={require("@assets/landing-page/hero3.png")}
            width={10}
            height={10}
            className={`moveCornerLeftRotateRightObject rounded-lg w-auto h-[40%] xs:h-[50%] sm:h-[60%] lg:h-[50%] xl:h-[70%] imageBorders absolute right-[10%] sm:right-[30%] xxl:right-[20%] bottom-0 xl:bottom-[-20%] z-10`}
            alt="hero"
          />
        </div>
      </div>
    </div>
  );
};

export default Subscribe;
